module.exports = __webpack_public_path__ + "img/title-text.dd840c30.png";